/**
 * Snaptrix pricing tiers for the landing page comparison table.
 * Billing: annual (discount vs seasonal), seasonal (April–September, 6 months).
 */
export const BILLING_PERIODS = {
  ANNUAL: "annual",
  SEASONAL: "seasonal",
};

export const pricingPlans = [
  {
    id: "small",
    name: "Starter",
    mostPopular: false,
    teams: "1 team",
    annual: "£120",
    perMonthAnnual: "£10",
    annualDiscount: "Save 33%",
    seasonal: "£90",
    perMonthSeasonal: "£15",
    seasonalDiscount: "6 months only",
    posts: "60/season",
    styles: "3 styles",
    users: "1 user",
    support: "Email",
    customDesigns: "1",
    bestFor: "Single Senior team",
    includesWomenAndJunior: "Included",
  },
  {
    id: "medium",
    name: "Club",
    mostPopular: true,
    teams: "2-4 teams",
    annual: "£240",
    perMonthAnnual: "£20",
    annualDiscount: "Save 33%",
    seasonal: "£180",
    perMonthSeasonal: "£30",
    seasonalDiscount: "6 months only",
    posts: "200/season",
    styles: "5 styles",
    users: "3 users",
    support: "Priority",
    customDesigns: "3 templates each",
    bestFor: "2-4 Senior Teams",
    includesWomenAndJunior: "Included",
  },
  {
    id: "large",
    name: "Premier",
    mostPopular: false,
    teams: "5+ teams",
    annual: "£400",
    perMonthAnnual: "£33",
    annualDiscount: "Save 33%",
    seasonal: "£300",
    perMonthSeasonal: "£50",
    seasonalDiscount: "6 months only",
    posts: "Unlimited",
    styles: "All + custom",
    users: "Unlimited",
    support: "Priority + call",
    customDesigns: "5 + Design consultation",
    bestFor: "5+ Senior Teams",
    includesWomenAndJunior: "Included",
  },
];
